import { useMemo, useState } from "react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";

const WHATSAPP_NUMBER = "212661213050";

export const RegistrationForm = ({ language, copy }) => {
  const [formData, setFormData] = useState({
    childName: "",
    birthYear: "",
    guardianName: "",
    phone: "",
    email: "",
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");

  const years = useMemo(() => {
    const values = [];
    for (let year = 2021; year >= 2011; year -= 1) {
      values.push(year);
    }
    return values;
  }, []);

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData((previous) => ({ ...previous, [name]: value }));
  };

  const openWhatsApp = (payload) => {
    const message = language === "ar"
      ? `مرحبًا، أود تسجيل طفل في نادي البراق الرياضي.%0Aالاسم الكامل: ${payload.childName}%0Aسنة الازدياد: ${payload.birthYear}%0Aاسم الولي: ${payload.guardianName || "-"}%0Aالهاتف: ${payload.phone}%0Aالبريد الإلكتروني: ${payload.email || "-"}`
      : `Bonjour, je souhaite inscrire un enfant au Club Al Buraq Sportif.%0ANom complet: ${payload.childName}%0AAnnée de naissance: ${payload.birthYear}%0AParent/Tuteur: ${payload.guardianName || "-"}%0ATéléphone: ${payload.phone}%0AEmail: ${payload.email || "-"}`;

    window.open(`https://wa.me/${WHATSAPP_NUMBER}?text=${message}`, "_blank", "noopener,noreferrer");
  };

  const handleSubmit = (event) => {
    event.preventDefault();

    if (!formData.phone.trim() || !formData.childName.trim() || !formData.birthYear) {
      toast.error(language === "ar" ? "يرجى ملء الحقول المطلوبة." : "Veuillez remplir les champs obligatoires.");
      return;
    }

    setIsSubmitting(true);
    setSuccessMessage("");

    setSuccessMessage(copy.success);
    toast.success(copy.success);
    openWhatsApp(formData);
    setFormData({ childName: "", birthYear: "", guardianName: "", phone: "", email: "" });
    setIsSubmitting(false);
  };

  return (
    <div className="registration-shell rounded-[2rem] border border-white/10 bg-[#07111f]/85 p-1 shadow-[0_30px_80px_rgba(0,0,0,0.35)]">
      <div className="registration-border-bar h-1 w-full rounded-full" />
      <form onSubmit={handleSubmit} className="space-y-6 rounded-[1.85rem] bg-[#081321]/92 p-5 sm:p-8">
        <div className="grid gap-5 md:grid-cols-2">
          <label className="space-y-2 text-sm text-slate-200">
            <span>{copy.childName}</span>
            <Input
              name="childName"
              value={formData.childName}
              onChange={handleChange}
              placeholder={copy.childName}
              className="h-12 rounded-2xl border-white/10 bg-white/5 text-white placeholder:text-slate-500"
              required
            />
          </label>

          <label className="space-y-2 text-sm text-slate-200">
            <span>{copy.birthYear}</span>
            <select
              name="birthYear"
              value={formData.birthYear}
              onChange={handleChange}
              className="h-12 w-full rounded-2xl border border-white/10 bg-white/5 px-4 text-white outline-none transition focus:border-[#5dade2]"
              required
            >
              <option value="" className="bg-slate-900 text-slate-300">
                {copy.birthYear}
              </option>
              {years.map((year) => (
                <option key={year} value={year} className="bg-slate-900 text-white">
                  {year}
                </option>
              ))}
            </select>
          </label>

          <label className="space-y-2 text-sm text-slate-200">
            <span>{copy.guardianName}</span>
            <Input
              name="guardianName"
              value={formData.guardianName}
              onChange={handleChange}
              placeholder={copy.guardianName}
              className="h-12 rounded-2xl border-white/10 bg-white/5 text-white placeholder:text-slate-500"
            />
          </label>

          <label className="space-y-2 text-sm text-slate-200">
            <span>{copy.phone}</span>
            <Input
              name="phone"
              type="tel"
              value={formData.phone}
              onChange={handleChange}
              placeholder={copy.phone}
              className="h-12 rounded-2xl border-white/10 bg-white/5 text-white placeholder:text-slate-500"
              required
            />
          </label>
        </div>

        <label className="space-y-2 text-sm text-slate-200">
          <span>{copy.email}</span>
          <Input
            name="email"
            type="email"
            value={formData.email}
            onChange={handleChange}
            placeholder={copy.email}
            className="h-12 rounded-2xl border-white/10 bg-white/5 text-white placeholder:text-slate-500"
          />
        </label>

        {successMessage ? (
          <p className="rounded-2xl border border-emerald-400/30 bg-emerald-400/10 px-4 py-3 text-sm text-emerald-200">
            {successMessage}
          </p>
        ) : null}

        <Button
          type="submit"
          disabled={isSubmitting}
          className="h-12 w-full rounded-full bg-gradient-to-r from-[#2980b9] via-[#5dade2] to-[#f39c12] text-base font-semibold text-slate-950 shadow-[0_18px_45px_rgba(41,128,185,0.35)] transition-transform duration-300 hover:-translate-y-0.5 hover:from-[#5dade2] hover:to-[#f39c12]"
        >
          {isSubmitting ? copy.loading : copy.submit}
        </Button>
      </form>
    </div>
  );
};
